import PDFWrapper, { DukeFooterLogo, Row, SignatureSection } from '../PdfLayout';
import { Text, View, StyleSheet, Page } from '@react-pdf/renderer';
import NonVocationalCertificateProps from './types';
import { Emblem } from '../Emblem';
import { Logo } from '../Logo';
import Table from './Table';

const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontSize: 12,
    fontFamily: 'Inter',
    position: 'relative',
  },
  outerBorder: {
    borderWidth: 4,
    borderColor: '#4532AD',
    margin: 30,
    padding: 2,
    flex: 1,
  },
  innerBorder: {
    borderWidth: 1,
    borderColor: '#4532AD',
    padding: 20,
    flex: 1,
  },
  emblemContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0.1,
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  body: {
    marginTop: 40,
    textAlign: 'center',
    fontSize: 16,
    marginBottom: 20,
    display: 'flex',
    gap: 20,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 20,
    right: 0,
    fontSize: 10,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
  },
  signatureImage: {
    width: 80,
    height: 30,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  nameAndCourseTitles: {
    fontSize: 11,
    fontFamily: 'Inter',
  },
  boldText: {
    fontSize: 24,
    fontWeight: 'bold',
    fontFamily: 'Inter-SemiBold',
  },
  signatureContainer: {
    marginTop: -10,
  },
});

function NonVocationalCertificate({
  data,
}: {
  data: NonVocationalCertificateProps;
}): React.ReactElement {
  return (
    <>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.emblemContainer}>
          <Emblem />
        </View>
        <View style={styles.outerBorder}>
          <View style={styles.innerBorder}>
            <View style={styles.logoContainer}>
              <Logo />
            </View>
            <View style={styles.body}>
              <Text>This is to certify that</Text>
              <Text style={styles.boldText}>{data.name}</Text>
              <Text>has completed the course</Text>
              <Text style={styles.boldText}>{data.course}</Text>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 20,
                  textAlign: 'center',
                  justifyContent: 'center',
                }}
              >
                <SignatureSection style={{ textAlign: 'center' }} includeCEOSignature />
              </View>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 20,
                  textAlign: 'center',
                  justifyContent: 'center',
                }}
              >
                <Row label="Date of issue:" value={data.completionDate} />
              </View>
            </View>
          </View>

          <View style={{ position: 'absolute', bottom: '16px', left: '36px' }}>
            <DukeFooterLogo />
          </View>
        </View>
      </Page>
      <PDFWrapper title="Record of Results">
        <View style={{ flexDirection: 'column', height: '100%' }}>
          <View style={styles.nameAndCourseTitles}>
            <Text style={{ marginTop: '6px' }}>
              Name of student:{' '}
              <Text style={{ fontWeight: 'bold', fontFamily: 'Inter-SemiBold' }}>{data.name}</Text>
            </Text>
            <Text style={{ marginTop: '6px' }}>
              Student ID:{' '}
              <Text style={{ fontWeight: 'bold', fontFamily: 'Inter-SemiBold' }}>{data.USI}</Text>
            </Text>
            <Text style={{ marginTop: '6px' }}>
              Date of issue:{' '}
              <Text style={{ fontWeight: 'bold', fontFamily: 'Inter-SemiBold' }}>
                {data.completionDate}
              </Text>
            </Text>
            <Text style={{ marginTop: '6px' }}>
              Course:{' '}
              <Text style={{ fontWeight: 'bold', fontFamily: 'Inter-SemiBold' }}>
                {data.course}
              </Text>
            </Text>
          </View>

          <Table data={data.units} />

          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: 10,
            }}
          >
            <View style={{ marginLeft: '8px', marginTop: 2 }}>
              <View style={{ marginTop: '6px' }}>
                <DukeFooterLogo />
              </View>
            </View>

            <View style={{ marginTop: '4px' }}>
              <SignatureSection includeCEOSignature />
            </View>
          </View>
        </View>
      </PDFWrapper>
    </>
  );
}

export default NonVocationalCertificate;
